import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import { BrandPopulationProgress } from "../../components/brand/BrandPopulationProgress";

export default function BrandPopulatingModal({ brandHash, onRefetchBrand }) {
  const navigate = useNavigate();
  const brandUrl = "/brand/profile/";

  const handleClose = () => {
    onRefetchBrand?.();
    navigate(brandUrl);
  };

  if (!brandHash) return null;

  return (
    <Modal onClose={handleClose}>
      <BrandPopulationProgress
        brandHash={brandHash}
        brandUrl={brandUrl}
        onBeforeNavigateToBrand={onRefetchBrand}
      />
    </Modal>
  );
}
